import {Component, Input, OnInit} from '@angular/core'
import moment from 'moment'
import {MatProgressBar} from '@angular/material/progress-bar'
import {MatDialog} from '@angular/material/dialog'
import {MatPaginator, PageEvent} from '@angular/material/paginator'
import {MatIcon} from '@angular/material/icon'
import {MatTooltip} from '@angular/material/tooltip'
import {AuthService} from '../../../core/services/auth/auth.service'
import {PagedContactTypeResponse} from '../../../core/models/contact-type.model'
import {EmployeeService} from '../../../core/services/employee/employee/employee.service'
import {ServiceOrderService} from '../../../core/services/service/service-order/service-order.service'
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion'
import {TableListOSComponent} from '../../../shared/components/table-list-os/table-list-os.component'
import {MatButton} from '@angular/material/button'
import {PassagersImportExcelComponent} from '../../passengers/passengers-import-excel/passengers-import-excel.component'
import {MatFormField, MatInput, MatLabel} from '@angular/material/input';
import {MatOption, MatSelect} from '@angular/material/select';
import {FormsModule} from '@angular/forms'
import {ProposalItemService} from '../../../core/services/proposal/proposal-item/proposal-item.service'
import {StretchTypeService} from '../../../core/services/stretch/stretch-type/stretch-type.service'
import {DriverTypeService} from '../../../core/services/driver/driver-type/driver-type.service'
import {VehicleTypeService} from '../../../core/services/vehicle/vehicle-type/vehicle-type.service'
import {
  ItemProposalCreateFormComponent
} from '../../proposal/item-proposal-create/item-proposal-create-form/item-proposal-create-form.component';
import { ItemProposalEditFormComponent } from '../../proposal/item-proposal-edit/item-proposal-edit-form/item-proposal-edit-form.component'
import {SnackbarCustomService} from '../../../shared/components/snackbar/snackbar-custom.service'

@Component({
  selector: 'logistics-item-proposal',
  imports: [
    MatProgressBar,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    TableListOSComponent,
    MatPaginator,
    MatButton,
    MatIcon,
    MatTooltip,
    MatFormField,
    MatInput,
    MatSelect,
    MatOption,
    MatLabel,
    FormsModule,
    ItemProposalCreateFormComponent,
    ItemProposalEditFormComponent,
  ],
  templateUrl: './logistics-item-proposal.component.html',
  styleUrl: './logistics-item-proposal.component.scss',
  standalone: true,
  providers: [EmployeeService, StretchTypeService, DriverTypeService, VehicleTypeService],
})
export class LogisticsItemProposalComponent implements OnInit {
  constructor(
    private dialog: MatDialog,
    private serviceOrderService: ServiceOrderService,
    private proposalItemService: ProposalItemService,
    private stretchTypeService: StretchTypeService,
    private driverTypeService: DriverTypeService,
    private vehicleTypeService: VehicleTypeService,
    private authService: AuthService,
    private snackbar: SnackbarCustomService,
  ) {}

  @Input() data: any
  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  searchResult: any = {
    itemPropostaId: 0,
    origemId: 0,
    descricaoOrigem: '',
    origemCidade: '',
    origemEstado: '',
    destinoId: 0,
    descricaoDestino: '',
    destinoCidade: '',
    destinoEstado: '',
    tipoServicoId: 0,
    descricaoTipoServico: '',
    servicoId: 0,
    descricaoServico: '',
    propostaId: 0,
    tipoMotoristaId: 0,
    tipoVeiculoId: 0,
    pax: 0,
    dataInicio: '',
    dataFinal: '',
    tipoTrechoId: 0,
  }
  loading = false
  searchForm: any = { search: false, model: {} }
  orderBySelected: string = ''
  stretchTypes: any[] = []
  driverTypes: any[] = []
  vehicleTypes: any[] = []
  itemSearchForm = {
    itemPropostaId: null as number | null,
    origemCidade: '',
    origemEstado: '',
    destinoCidade: '',
    destinoEstado: '',
    tipoMotoristaId: null as number | null,
    tipoVeiculoId: null as number | null,
    tipoTrechoId: null as number | null,
    pax: null as number | null,
    dataInicio: '',
    dataFinal: '',
  }
  sorts: any[] = [
    { id: 'pax:asc', description: 'Pax' },
    { id: 'servico:asc', description: 'Serviço' },
    { id: 'origemDestinoLogistica:asc', description: 'Trecho' },
    { id: 'valor:asc', description: 'Valor' },
    { id: 'valorExtra:asc', description: 'Valor Extra' },
    { id: 'veiculo:asc', description: 'Veículo' },
  ]
  sortChange(event: any) {
    this.orderBySelected = event.value
    this.page = 1
    this.uploadList()
  }
  columns: any[] = [
    {keyColumn: 'logistica_origem',      key: '_origem',      description: 'Origem'},
    {keyColumn: 'logistica_destino',     key: '_destino',     description: 'Destino'},
    {keyColumn: 'os_service',            key: 'os_service',   description: 'Serviço'},
    {keyColumn: 'os_vehicle',            key: 'os_vehicle',   description: 'Veículo'},
    {keyColumn: 'pax',                   key: 'quantidadePassageiros', description: 'Pax'},
    {keyColumn: 'logistica_valor',       key: '_valor',       description: 'Valor'},
    {keyColumn: 'logistica_valor_extra', key: '_valorExtra',  description: 'Valor Extra'},
    {keyColumn: 'action', key: { edit: false, delete: false, replierItem: false, lookForAlert: false }, description: 'Ações'},
  ]
  screen = 'tipo serviço'
  ngOnInit() {
    this.searchResult = {
      ...this.searchResult,
      propostaId: this.data.propostaId,
    }
    this.checkColumnAction()
    this.getListItems()
    this.loadStretchTypes()
  }

  loadStretchTypes() {
    this.stretchTypeService.listStretchType().subscribe({
      next: (res: any) => { this.stretchTypes = res.data || [] },
      error: () => {},
    })
    this.driverTypeService.listDriverType().subscribe({
      next: (res: any) => { this.driverTypes = res.data || [] },
      error: () => {},
    })
    this.vehicleTypeService.listVehicleType().subscribe({
      next: (res: any) => { this.vehicleTypes = res.data || [] },
      error: () => {},
    })
  }

  clearSearch() {
    this.itemSearchForm = {
      itemPropostaId: null,
      origemCidade: '',
      origemEstado: '',
      destinoCidade: '',
      destinoEstado: '',
      tipoMotoristaId: null,
      tipoVeiculoId: null,
      tipoTrechoId: null,
      pax: null,
      dataInicio: '',
      dataFinal: '',
    }
    this.searchForm = { search: false, model: {} }
    this.page = 1
    this.uploadList()
  }

  performSearch() {
    this.searchForm = {
      search: true,
      model: this.buildSearchPayload(this.itemSearchForm),
    }
    this.page = 1
    this.uploadList()
  }

  buildSearchPayload(form: any) {
    return {
      ...this.searchResult,
      itemPropostaId: form.itemPropostaId || 0,
      origemCidade: form.origemCidade || '',
      origemEstado: form.origemEstado || '',
      destinoCidade: form.destinoCidade || '',
      destinoEstado: form.destinoEstado || '',
      tipoMotoristaId: form.tipoMotoristaId || 0,
      tipoVeiculoId: form.tipoVeiculoId || 0,
      tipoTrechoId: form.tipoTrechoId || 0,
      pax: form.pax || 0,
      dataInicio: form.dataInicio || '',
      dataFinal: form.dataFinal || '',
    }
  }

  checkColumnAction() {
    const index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: false,
        view: true,
        delete: true,
        replierItem: true,
        lookForAlert: false,
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  getSearchItems(model: any) {
    this.loading = true
    this.proposalItemService.searchPagedByProposalLogistics(this.page, this.rows, model, this.orderBySelected).subscribe({
      next: (response: any) => {
        this.treatResponse(response)
        this.loading = false
      },
      error: (err: PagedContactTypeResponse) => {
        this.snackbar.error('Não foi possível listar os itens de proposta.')
        this.loading = false
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  createModelSearch(model: any) {
    return {
      nome: model.nome || null,
      documento: model.documento || null,
      contato: model.contato || null,
      cpf: model.cpf || null,

      tipoTrechoId: model.tipoTrechoId || null,
      destinoOrigemVoo: model.destinoOrigemVoo || null,

      dataVoo: model.data || null,
      horaVoo: model.hora || null,

      companhia: model.companhia || null,
      numeroVoo: model.voo || null,
    }
  }

  search(event: any) {
    this.searchForm = {
      search: event.search,
      model: this.createModelSearch(event.model),
    }
    this.page = 1
    this.uploadList()
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
    // this.search(this.searchResult)
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1
    this.rows = event.pageSize
    this.uploadList()
    // this.search(this.searchResult)
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1
    this.uploadList()
  }

  uploadList() {
    if (this.searchForm.search) {
      this.getSearchItems(this.searchForm.model)
    } else {
      this.getListItems()
    }
    // this.getListItems()
  }

  getInfoPasseger(item: any) {
    switch (item.tipo_trecho_id) {
      case 1: // Transfer In
      case 2: // Transfer Out
      case 3: // PAP In
      case 4: // PAP Out
        return `${item.data} - ${item.hora}`
      case 5: // PAP Aéreo In
      case 6: // PAP Aéreo Out
      case 7: // Outros
        return `${item.companhia} ${item.voo} | ${item.data} - ${item.hora} | ${item.destino_origem_aero}`
      default:
        return '-'
    }
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        const paisO = item.paisOrigem ? ` (${item.paisOrigem})` : ''
        const paisD = item.paisDestino ? ` (${item.paisDestino})` : ''
        list.push({
          ...item,
          tipoServico: item.descricaoTipoServico || '-',
          servico: item.descricaoServico || '-',
          nomeTipoVeiculo: item.descricaoTipoVeiculo || '-',
          nomeTipoMotorista: item.descricaoTipoMotorista || '-',
          _origem: `Cidade: ${item.cidadeOrigem || '-'}\nEstado: ${item.estadoOrigem || '-'}${paisO}`,
          _destino: `Cidade: ${item.cidadeDestino || '-'}\nEstado: ${item.estadoDestino || '-'}${paisD}`,
          _valor: `Valor: R$ ${this.formatCurrency(item.valorVenda)}\nC. Taxa: R$ ${this.formatCurrency(item.valorComTaxa)}`,
          _valorExtra: `Hora: R$ ${this.formatCurrency(item.custoHoraExtra)}\nKM: R$ ${this.formatCurrency(item.custoKmExtra)}`,
        })
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  private formatCurrency(value: any): string {
    if (value == null) return '-'
    const n = typeof value === 'number' ? value : parseFloat(value)
    if (isNaN(n)) return '-'
    return n.toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2})
  }
  getListItems() {
    this.loading = true
    this.proposalItemService
      .searchPagedByProposalLogistics(this.page, this.rows, this.searchResult, this.orderBySelected)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  // searchListItems() {
  //   this.loading = true
  //   this.serviceOrderService
  //     .searchPagedServiceOrder(this.page, this.rows, this.searchForm)
  //     .subscribe({
  //       next: (response: any) => {
  //         this.treatResponse(response)
  //       },
  //       error: (err: PagedContactTypeResponse) => { },
  //       complete: () => {
  //         this.loading = false
  //       },
  //     })
  // }

  editItem(item: any) {
    this.loading = true
    this.proposalItemService.getProposalItembyId(item.id).subscribe({
      next: (res: any) => {
        this.loading = false
        const fullItem = res.data
        const proposalInfo = {
          statusPropostaId: this.data.statusPropostaId ?? 4,
          clienteId: this.data.idCliente ?? this.data.clienteId ?? 0,
          subClienteId: this.data.subClienteId ?? 0,
        }
        const dialogRef = this.dialog.open(ItemProposalEditFormComponent, {
          data: { edit: true, item: fullItem, proposalInfo, viewOnly: true },
          enterAnimationDuration: '100ms',
          exitAnimationDuration: '100ms',
          maxWidth: '100vw',
          width: '100vw',
          maxHeight: '100vh',
          height: '100vh',
          panelClass: 'dialog-fullscreen',
        })
        dialogRef.componentInstance.response.subscribe(() => this.uploadList())
      },
      error: () => {
        this.loading = false
        this.snackbar.error('Não foi possível carregar o item de proposta.')
      },
    })
  }

  replierItem(item: any) {
    this.loading = true
    this.proposalItemService.duplicateProposalItem(item.id).subscribe({
      next: () => {
        this.snackbar.success('Item de proposta duplicado com sucesso!')
        this.uploadList()
      },
      error: (err: any) => {
        this.snackbar.errorRequest(err)
        this.loading = false
      },
    })
  }

  deleteItem(item: any) {
    if (confirm('Deseja realmente excluir este item?')) {
      this.loading = true
      this.proposalItemService.removeProposalItem(item.id).subscribe({
        next: () => {
          this.uploadList()
        },
        error: (err) => {
          console.error(err)
          this.loading = false
        },
      })
    }
  }
  importPassenger() {
    console.log('importando viu')
    const dialogRef = this.dialog.open(PassagersImportExcelComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      data: { edit: false, idContrato: this.data.id },
    })

    dialogRef.componentInstance.response.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }
  addItemProposal() {
    const dialogRef = this.dialog.open(ItemProposalCreateFormComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: {
        idClient: this.data.idCliente,
        period: {
          dataInicio: this.data.dataInicio,
          dataFim: this.data.dataFim,
        },
      },
    })

    dialogRef.componentInstance.response.subscribe((response) => {
      if (response) {
        this.loading = true
        const model = this.mapToExpectedModel(response)
        this.proposalItemService.createProposalItemWithItinerariesPostProposal(model).subscribe({
          next: () => {
            this.snackbar.success('O item de proposta foi adicionado com sucesso!')
            this.uploadList()
          },
          error: (err) => {
            console.error(err)
            this.loading = false
          },
        })
      }
    })
  }

  mapToExpectedModel(response: any) {
    return {
      propostaId: this.data.propostaId,
      tarifarioId: response.tarifarioId || null,
      tipoTarifarioId: response.tipoTarifarioId || null,
      perimetroUrbano: response.perimetroUrbano || null,
      origemId: response.origemId || 0,
      destinoId: response.destinoId || 0,
      tipoServicoId: response.tipoServicoId || null,
      servicoId: response.servicoId || null,
      tipoVeiculoId: response.tipoVeiculoId || null,
      tipoMotoristaId: response.tipoMotoristaId || null,
      numPessoas: response.numPessoas || 0,
      numVeiculos: response.numVeiculos || 0,
      valorUnitario: this.parseVal(response.vendaUnitario),
      valorTaxa: this.parseVal(response.valorTaxa),
      valorVenda: this.parseVal(response.vendaSemTaxa),
      valorComTaxa: this.parseVal(response.venda),
      valorKmVenda: this.parseVal(response.saleKmExtra),
      valorHoraVenda: this.parseVal(response.saleHoraExtra),
      isPermuta: response.isPermuta ? 'S' : 'N',
      isComissiona: response.isComisionado ? 'S' : 'N',
      isCortesia: response.isCortesia ? 'S' : 'N',
      dataInicio: response.dataInicio ? moment(response.dataInicio, ['YYYY-MM-DD', 'DD/MM/YYYY']).format('DD/MM/YYYY') : null,
      horaInicio: this.toHHMMSS(response.horaInicio || ''),
      dataFinal: response.dataFinal ? moment(response.dataFinal, ['YYYY-MM-DD', 'DD/MM/YYYY']).format('DD/MM/YYYY') : null,
      horaFinal: this.toHHMMSS(response.horaFinal || ''),
      taxa: Number(response.taxa) || 0,
      divisor: Number(response.divisor) || 0,
      comissao: Number(response.comissao) || 0,
      tipoDivisor: response.tipoComissao || null,
      observacao: response.observacao || '',
      itinerarios: (response.intinerarios || []).map((iti: any) => ({
        localParada: iti.localParada || '',
        cep: iti.cep || '',
        logradouro: iti.logradouro || '',
        numero: iti.numero || '',
        bairro: iti.bairro || '',
        complemento: iti.complemento || '',
        descricao: iti.descricao || '',
        cidade: iti.cidade || '',
        estado: iti.estado || '',
        latitude: iti.latitude || 0,
        longitude: iti.longitude || 0,
        trecho: iti.trecho || '',
        areaTarifario: iti.areaTarifario || '',
      })),
    }
  }

  private toHHMMSS(hora: string): string {
    if (!hora) return null as any
    const parts = hora.split(':')
    return parts.length === 3 ? hora : `${hora}:00`
  }

  private parseVal(value: any): number {
    if (typeof value === 'number') return value
    if (typeof value === 'string') {
      const n = parseFloat(value.replaceAll('.', '').replaceAll(',', '.'))
      return isNaN(n) ? 0 : n
    }
    return 0
  }
}


/*
- id
- nome
- documento
- contato
- companhia
- cpf
- tipo_trecho_id
- voo
- hora
- data
- destino_origem_aero
- uf_aero
- logradouro_aero
- numero_aero
- bairro_aero
- cidade_aero
- complemento_aero
- estado_aero
- uf_pap
- logradouro_pap
- numero_pap
- bairro_pap
- cidade_pap
- complemento_pap
*/
